import { useMemo } from "react";

// Apple-style concentric dot halo. Colors sweep through the Meranggi navy -> red brand range.
const RINGS = [
  { r: 38, count: 16, size: 3.2, dur: 30 },
  { r: 52, count: 22, size: 3.6, dur: 40 },
  { r: 66, count: 28, size: 4, dur: 52 },
  { r: 80, count: 34, size: 4.4, dur: 66 },
];

// Brand palette only: navy -> royal blue -> brand red -> back to navy.
const STOPS = [
  [16, 35, 63],
  [30, 79, 161],
  [10, 102, 255],
  [200, 16, 46],
  [163, 13, 38],
  [16, 35, 63],
];

const hue = (t) => {
  const p = t * (STOPS.length - 1);
  const i = Math.min(Math.floor(p), STOPS.length - 2);
  const f = p - i;
  const [r, g, b] = STOPS[i].map((c, k) => Math.round(c + (STOPS[i + 1][k] - c) * f));
  return `rgb(${r} ${g} ${b})`;
};

export const DotHalo = ({ children }) => {
  const dots = useMemo(
    () =>
      RINGS.map((ring, ri) => ({
        ...ring,
        ri,
        items: Array.from({ length: ring.count }, (_, i) => {
          const t = i / ring.count;
          const a = t * Math.PI * 2;
          return {
            x: Math.cos(a) * ring.r,
            y: Math.sin(a) * ring.r,
            color: hue(t),
            delay: (i / ring.count) * 2.2,
          };
        }),
      })),
    []
  );

  return (
    <div className="relative grid h-[210px] w-[210px] place-items-center">
      {dots.map((ring) => (
        <div
          key={ring.ri}
          className="absolute inset-0 grid place-items-center"
          style={{
            animation: `halo-spin ${ring.dur}s linear infinite${ring.ri % 2 ? " reverse" : ""}`,
          }}
        >
          {ring.items.map((d, i) => (
            <span
              key={i}
              className="absolute rounded-full"
              style={{
                width: ring.size,
                height: ring.size,
                background: d.color,
                transform: `translate(${d.x}px, ${d.y}px)`,
                animation: `halo-breathe 3.6s ease-in-out ${d.delay}s infinite`,
              }}
            />
          ))}
        </div>
      ))}
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default DotHalo;
